module.exports = __webpack_public_path__ + "static/media/icons8-high priority white.7d83a840.svg";